<mat-card-header [ngClass]="error ? 'system-message error' : ''">
  <mat-card-title class="nsc-card-title">
    <h3>
      <ng-content></ng-content>
      <span class="nsc-card-title__note mat-caption" *ngIf="note">{{ note }}</span>
    </h3>
  </mat-card-title>
  <div class="nsc-card-title__help" *ngIf="helpText">
    <button mat-icon-button aria-label="Information" id="{{id}}_helpicon" (click)="openHelpDialog()">
      <mat-icon aria-hidden="true">info</mat-icon>
    </button>
  </div>
</mat-card-header>